module.exports = __webpack_public_path__ + "static/banner-4ea7cd129714511c7e3e03938f552d7b.png";